<template>
  <!--角色管理 -->
  <div class="newsPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>审核状态：</div>
          <el-select v-model="examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':'2','value':'待审核'},{'key':'1','value':'审核通过'},{'key':'3','value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
          <div>专题名称：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px" v-model="specialName"></el-input>
          <div>所属城市：</div>
          <el-select size="small" style="width: 180px;margin-right: 10px;" v-model="areaCode" placeholder="请选择">
            <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <div>是否轮播：</div>
          <el-select size="small" style="width: 180px;margin-right: 10px;" v-model="isRotation" placeholder="请选择">
            <el-option
                v-for="item in [{name:'是',id:'1'},{name:'否',id:'0'}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <div>数据流数：</div>
          <el-input clearable placeholder="请输入搜索内容" size="small" style="width: 180px;margin-right: 10px" v-model="streamNumber"></el-input>
          <el-button @click="searchBtn" type="primary" size="small">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="auditBatchList&&auditBatchList.length" @click="auditBatchBtn" size="small" type="danger">批量审核</el-button>
          <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>
        </div>
        <el-table
            size="small"
            ref="multipleTable"
            tooltip-effect="dark"
            :data="tableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
              type="selection"
              align="center"
              width="55">
          </el-table-column>
          <el-table-column width="180" label="封面图" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-image
                    style="width: 160px; height: 80px"
                    :src="scope.row.img_url"
                    :preview-src-list="scope.row.img_urlList">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="专题名称" width="240" prop="special_name" align="center"></el-table-column>
          <el-table-column label="发布者" prop="nickname" align="center"></el-table-column>
          <el-table-column label="城市" width="60" prop="area_name" align="center"></el-table-column>
          <el-table-column label="专题说明" width="300" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.special_explain}}
                </template>
                <span style="width:270px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.special_explain }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column label="数据流位置" width="150" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.stream_number ? '第' + scope.row.stream_number + '数据流' : ''}}</div>
            </template>
          </el-table-column> -->
          <el-table-column label="数据流数" prop="stream_number" align="center"></el-table-column>
          <el-table-column label="是否轮播" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.is_rotation == '1' ?'是':'否'}}</div>
            </template>
          </el-table-column>
<!--          <el-table-column label="权重时间" width="120" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <a-tooltip placement="right" trigger="click">-->
<!--                <template slot="title">-->
<!--                  {{scope.row.sortTime}}-->
<!--                </template>-->
<!--                {{ scope.row.sortTimeList[0] }}-->
<!--              </a-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="创建时间" width="120" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.create_date}}
                </template>
                {{ scope.row.create_date.split(' ')[0] }}
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="100" label="审核状态">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag type="warning" size="small" effect="dark" v-if="scope.row.examine_status === '2'">待审核</el-tag>
                <el-tag type="success" size="small" effect="dark" v-else-if="scope.row.examine_status === '1'">审核通过</el-tag>
                <el-tag type="danger" size="small" effect="dark" v-else-if="scope.row.examine_status === '3'">审核未通过</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              width="300px"
              align="center"
              label="操作"

          >
            <template slot-scope="scope">
              <el-button
                @click="copy"
                type="primary"
                size="mini"
                class="btns"
                :data-clipboard-text="'https://www.weiguanzixun.com/special?id=' + scope.row.id+'&type='+scope.row.special_type"
            >复制链接</el-button>
              <el-button @click="auditBtn(scope.row)" v-if="scope.row.examine_status === '2'" size="small" type="success">审核</el-button>
              <el-button @click="editBtn(scope.row)" size="small" type="success">修改</el-button>
              <el-button @click="deleteBtn(scope.row)" size="small" type="danger">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>
    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{simpleDelete?'是否删除该条记录？':'是否删除当前所选中的记录？'}}</div>
    </a-modal>

    <a-modal
        :visible="editDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="修改"
        width="500px"
        @cancel="editCancel"
        @ok="editSubmit('editRuleForm')"
    >
      <el-form
          ref="editRuleForm"
          :model="editRuleForm"
          class="small-space"
          label-position="right"
          label-width="100px"
      >

        <el-form-item label="权重时间">
          <el-date-picker
              v-model="editRuleForm.sort"
              style="width: 300px"
              type="datetime"
              value-format="timestamp"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
              v-model="editRuleForm.createDate"
              style="width: 300px"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="数据流数">
          <el-input-number :min="0" v-model="editRuleForm.streamNumber" style="width: 300px"></el-input-number>
        </el-form-item>
        <el-form-item label="专题名称">
          <el-input v-model="editRuleForm.specialName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="专题说明">
          <el-input v-model="editRuleForm.specialExplain" type="textarea" style="width: 300px" :rows="5" ></el-input>
        </el-form-item>
        <el-form-item label="所属页面">
          <el-select style="width: 300px" v-model="editRuleForm.menuId" placeholder="请选择">
            <el-option
                v-for="item in [{key:'1',value:'首页'},{key:'2',value: '政务号'},{key:'3',value: '企业号'},{key:'4',value: '大V号'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属城市">
          <el-select style="width: 300px" v-model="editRuleForm.areaCode" placeholder="请选择">
            <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否轮播">
          <el-select style="width: 300px" v-model="editRuleForm.isRotation" placeholder="请选择">
            <el-option
                v-for="item in [{name:'是',id: '1'},{name:'否',id:'0'}]"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    审核的弹窗-->
    <a-modal
        :visible="auditDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="审核"
        width="400px"
        @cancel="auditCancel"
        @ok="auditSubmit('auditRuleForm')"
    >
      <el-form
          ref="auditRuleForm"
          :model="auditRuleForm"
          :rules="auditRules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="审核状态" prop="examineStatus">
          <el-select v-model="auditRuleForm.examineStatus" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择审核状态">
            <el-option
                v-for="item in [{'key':'1','value':'审核通过'},{'key':'3','value':'审核未通过'}]"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      examineStatus:null,
      areaCode:null,
      isRotation:null,
      specialName:'',
      streamNumber:'',
      tableData:[],
      totalElements: 0,//数据总数
      multipleSelection:[],
      auditBatchList:[],
      deleteDialogState:false,
      deleteId:'',
      simpleDelete:false,//是单个删除还是多个删除
      auditDialogState:false,
      auditRuleForm:{
        examineStatus:null
      },
      auditRules:{
        examineStatus: [{required: true, message: "请选择审核状态", trigger: "blur"}],
      },
      simpleAudit:false,
      auditId:'',
      editDialogState:false,
      areaData: [],
      editRuleForm:{
        id:'',
        sort:0,
        createDate:'',
        specialName:'',
        specialExplain:'',
        streamNumber:1,
        menuId:null,
        areaCode:null,
        isRotation: null
      }
    };
  },
  methods: {
    copy() {
      var that = this;
      var clipboard = new Clipboard(".btns"); //单页面引用
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        this.$message.error("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getNewsList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.specialName = ''
      this.streamNumber = ''
      this.examineStatus = null
      this.areaCode = null
      this.isRotation = null
      this.getNewsList()
    },
    dateChange(e){
      this.dateValue = e
      this.createStartDate = moment(this.dateValue[0]).format('YYYY-MM-DD')
      this.createEndDate = moment(this.dateValue[1]).format('YYYY-MM-DD')
    },
    editBtn(row){
      this.editRuleForm.id = row.id
      this.editRuleForm.createDate = row.create_date
      this.editRuleForm.areaCode = row.area_code
      this.editRuleForm.specialName = row.special_name
      this.editRuleForm.sort = Number(row.sort)*1000
      this.editRuleForm.specialExplain = row.special_explain
      this.editRuleForm.streamNumber = row.stream_number
      this.editRuleForm.menuId = row.menu_id
      this.editRuleForm.isRotation = row.is_rotation
      this.editDialogState = true
    },
    deleteBtn(row){
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    auditBtn(row){
      this.simpleAudit = true
      this.auditId = row.id
      this.auditRuleForm.examineStatus = '1'
      this.auditDialogState = true
    },
    batchDeleteBtn(){
      this.simpleDelete = false
      this.auditRuleForm.examineStatus = '1'
      this.deleteDialogState = true
    },
    auditBatchBtn(){
      this.simpleAudit = false
      this.auditDialogState = true
    },
    deleteCancel(){
      this.deleteDialogState = false
    },
    auditCancel(){
      this.auditDialogState = false
    },
    editCancel() {
      this.editDialogState = false
    },
    editSubmit(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editRuleForm.sort.toString().length === 13){
            this.editRuleForm.sort = Number(this.editRuleForm.sort)/1000
          }
          this.postAxios("/examine/special/updSpecialById", this.editRuleForm).then(res=>{
            if (res.success){
              this.$message.success(res.message)
              this.editDialogState = false
              this.getNewsList()
            }else{
              this.$message.success(res.message)
            }
          })
        }
      });
    },
    auditSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.simpleAudit){
            this.postAxios("/examine/special/examineSpecialByIds", {
              examineStatus:this.auditRuleForm.examineStatus,
              ids:[this.auditId]
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditId = ''
                this.auditDialogState = false
                this.getNewsList()
              }
            })
          }else{
            this.postAxios("/examine/special/examineSpecialByIds", {
              examineStatus:this.auditRuleForm.examineStatus,
              ids:this.auditBatchList
            }).then(res=>{
              if (res.success){
                this.$message.success(res.message)
                this.auditBatchList = []
                this.multipleSelection = []
                this.auditDialogState = false
                this.getNewsList()
              }
            })
          }
        }
      });
    },
    deleteSubmit(){
      if (this.simpleDelete){
        //单个删除
        this.postAxios("/examine/special/delSpecialByIds", [
          this.deleteId
        ]).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getNewsList()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item)=>{
          ids.push(item.id)
        })
        this.postAxios("/examine/special/delSpecialByIds", ids).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getNewsList()
          }
        })
      }
    },
    //用户列表
    getNewsList() {
      this.postAxios("/examine/special/getAllSpecial", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          examineStatus: this.examineStatus?this.examineStatus:null,
          specialName: this.specialName,
          streamNumber: this.streamNumber,
          areaCode: this.areaCode,
          isRotation: this.isRotation
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.tableData.forEach((item)=>{
            item.img_urlList = []
            if (item.img_url) {
              item.img_urlList.push(item.img_url)
            }
            if (item.sort || item.sort === 0){
              item.sortTime = moment(Number(item.sort)*1000).format('YYYY-MM-DD HH:mm:ss')
              item.sortTimeList = item.sortTime.split(' ')
            }
          })
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.auditBatchList = []
      if (this.multipleSelection&&this.multipleSelection.length){
        this.multipleSelection.forEach((item)=>{
          if (item.examine_status === '2' || item.examine_status === '3'){
            this.auditBatchList.push(item.id)
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    }
  },
  created() {
    this.getNewsList(); //用户的列表
    this.postAxios("/examine/special/getAllOpenUpArea", {
    }).then(res=>{
      if (res && res.success){
        this.areaData = res.content
      }
    })
  }
};
</script>
<style lang="less" scoped>

</style>
